import { createFileRoute } from "@tanstack/react-router";

import Error from "@/containers/Error";

export const Route = createFileRoute("/$code")({
  component: RouteComponent,
});

function RouteComponent() {
  const { code } = Route.useParams();
  const errorCode = ["403", "404", "500"].includes(code) ? parseInt(code) : 404;
  
  return <Error code={errorCode} />;
}
